import type { SVGProps } from 'react';

const SvgLongArrowLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 66 19" {...props}>
    <path
      fill={props.color}
      d="M9.8 2.56 4.452 8.44h61.52v2.52H4.452L9.8 16.84l-1.792 1.736L0 9.7 8.008.824z"
    />
  </svg>
);

export default SvgLongArrowLeft;
